module.exports = __webpack_public_path__ + "static/sapn-b580c63f0f5167805115a8c856a7754e.jpg";